if (!customElements.get("pickup-availability-drawer-header")) {
  customElements.define(
    "pickup-availability-drawer-header",
    class PickupAvailabilityDrawerHeader extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        // Add event listener for the close button
        const closeButton = this.querySelector(
          "[data-pickup-availability-drawer-close]"
        );
        if (closeButton) {
          closeButton.addEventListener("click", () => {
            this.hide();
          });
        }
        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        const iconStore = document.querySelector(
          "[data-store-selector-header]"
        );
        iconStore.addEventListener("click", (evt) => {
          evt.stopPropagation();
          document
            ?.querySelector("pickup-availability-drawer-header")
            ?.show(evt.target, true);
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer-header") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden", "drawer--open");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden", "drawer--open");
        trapFocus(this);
      }
    }
  );
}
